export const apiBasePath = '/api/admin/events/';
export const apiConfigurationPath = '/api/admin/configurations/';
export default {};



// WEBPACK FOOTER //
// ./src/admin/pages/Events/common/globals.js